export function convertElementToFragment(element: Element): DocumentFragment {
    const fragment = document.createDocumentFragment();

    while (element.firstChild !== null) {
        fragment.appendChild(element.firstChild);
    }

    return fragment;
}
